export const OssScene = {
  avatar: 'avatar',
  product: 'product',
  chat: 'chat',
  identify: 'identify',
  comment: 'comment',
  signature: 'sign',
  enterpriseLicense: 'enterprise_license',
  pdfContract: 'pdfcontracts',
} as const;

export type OssSceneValue = typeof OssScene[keyof typeof OssScene];
